import React from 'react'
import Reset from '../Reset/Reset'

const TimelineTitle = (props) => {
    return (
        <div className="row">
            <div className="col-lg-12 text-center">
                <h2 className="section-heading">{props.timeline.title}</h2>
                <h3 className="section-subheading text-muted">{props.timeline.subtitle}</h3>
            </div>
        </div>
    );
}

const TimelineItem = (props) => {

    const style = (props.index % 2) === 0 ? "timeline" : "timeline-inverted"

    const info = {
        title : props.title,
        subtitle: props.subtitle,
        image: props.full_image
    }

    return (
        <li className={style}>
            <div className="timeline-image">
                <a className="portfolio-link" data-toggle="modal" target="_self"
                    href="#portfolioModal" onClick={() => props.showModal(info)} >
                    <img className="img-fluid" src={props.image} alt={props.alt} /></a>
            </div>
            <div className="timeline-panel">
                <div className="timeline-heading">
                    <h4>{props.title}</h4>
                    <h4 className="subheading">{props.subtitle}</h4>
                </div>
                <div className="timeline-body">
                    <div className="text-muted">
                        {props.content.map((c, k) => (
                            <div key={k} dangerouslySetInnerHTML={{ __html: c }}></div>
                        ))}</div>
                </div>
            </div>
        </li>
    )
}

const Timeline = (props) => {
    return (
        <section className="page-section" id={props.timeline.key}>
            <div className="container">
                <TimelineTitle {...props}></TimelineTitle>
                <div className="row">
                    <div className="col-lg-12">
                        <ul className="timeline">
                            {props.timeline.items.map((e, v) => (
                                <TimelineItem key={v} index={v} {...e} showModal={props.showModal} />
                            ))}
                        </ul>
                    </div>
                </div>
                <Reset></Reset>
            </div>
        </section>
    );

}

export default Timeline;